import './ToleranceField.css';

import React, {  } from 'react';
import { generateClassName, roundDecimalNumber } from '../../../b2b-common/helpers';
import FieldComponent from '../../../b2b-common/FieldComponent';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import FieldText from '../../../b2b-common/FieldText';

const ToleranceField = ({ objective, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const exceedesTolerance = objective.totalFails > objective.penalties;

    if (objective.penaltiesExpressedAs === 'ABSOLUTE_VALUE')
        return (
            <FieldComponent
                label={`${t('Tolerance expressed as absolute value')}`}
                labelAlign='left'
                component={
                    <>
                        <FieldText
                            label={t('Max Value:')}
                            labelAlign='left'
                            text={`${objective.penalties}`}
                            textAlign='left'
                            className={`${generateClassName('tolerance-max-field', '-value', className)} theme-fieldtex-horizontal-02`}
                        />
                        <FieldText
                            label={t('Current Value:')}
                            labelAlign='left'
                            text={`${objective.totalFails}`}
                            textAlign='left'
                            className={`${generateClassName('tolerance-current-field', '-value', className)} ${exceedesTolerance ? 'exceeds-max' : ''} theme-fieldtex-horizontal-02`}
                        />
                    </>
                }
                className={generateClassName('tolerance-field', '', className)}
            />
        );
    else if (objective.penaltiesExpressedAs === 'PERCENTAGE')
        return (
            <FieldComponent
                label={`${t('Tolerance expressed as %')}`}
                labelAlign='left'
                component={
                    <>
                        <FieldText
                            label={t('Max Value:')}
                            labelAlign='left'
                            text={`${objective.penalties} %`}
                            textAlign='left'
                            className={`${generateClassName('tolerance-max-field', '-value', className)} theme-fieldtex-horizontal-02`}
                        />
                        <FieldText
                            label={t('Current Value:')}
                            labelAlign='left'
                            text={`${roundDecimalNumber(objective.totalFails)} %`}
                            textAlign='left'
                            className={`${generateClassName('tolerance-current-field', '-value', className)} ${exceedesTolerance ? 'exceeds-max' : ''} theme-fieldtex-horizontal-02`}
                        />
                    </>
                }
                className={generateClassName('tolerance-field', '', className)}
            />
        );
    else
        return null;
}

export default ToleranceField;